// extracted by mini-css-extract-plugin
export default {"shirtHelpText":"RegistrationProfile_shirtHelpText__MPowa","profilePicMedia":"RegistrationProfile_profilePicMedia__F6ws3"};